import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SpacerVertical, ParagraphTertiary, constants } from '@klarna/bubble-ui';
import { Flex } from '@klarna/mp-ui';

const HeaderCell = ({ children }) => {
  return (
    <Flex
      style={{
        borderTopColor: constants.Colors.DIVIDER,
        borderBottomColor: constants.Colors.DIVIDER_STRONG,
        borderStyle: 'solid',
        borderWidth: '1px 0',
      }}
    >
      <SpacerVertical extraSmall />
      <Flex style={{ padding: '0.5em 1em' }}>
        <ParagraphTertiary bold correctFootprint>
          {children}
        </ParagraphTertiary>
      </Flex>
      <SpacerVertical extraSmall />
    </Flex>
  );
};

HeaderCell.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeaderCell;
